import { Card } from 'react-bootstrap';
import { planContractUrl } from '../../../../services/PublicPlanSignupService';
import { formatBrl } from '../shared/publicBrand';

/**
 * "Meu plano" no ambiente do cliente: nome do plano, quanto ele já economizou e o contrato.
 *
 * A economia vem pronta do backend (soma dos descontos gravados nas vendas); aqui só se
 * apresenta. Não aparece para quem não tem plano, e não mostra "economizou R$ 0,00" para o
 * assinante recém-chegado: nesse caso fala do que ele ainda vai ganhar.
 */
const PlanSummaryCard = ({ customer, companyUuid }) => {
    if (!customer?.subscriptionCustomer || !customer.planName) return null;

    const total = Number(customer.planSavingsTotal || 0);
    const month = Number(customer.planSavingsMonth || 0);
    const since = customer.planSavingsSince
        ? new Date(`${customer.planSavingsSince}T00:00:00`).toLocaleDateString('pt-BR')
        : '';

    return (
        <Card className="booking-card shadow-lg mb-4 plan-summary-card">
            <Card.Body className="p-4">
                <div className="d-flex flex-wrap justify-content-between align-items-start gap-2 mb-2">
                    <div>
                        <span className="booking-toolbar-eyebrow">Meu plano</span>
                        <h5 className="mb-0">{customer.planName}</h5>
                    </div>
                    {customer.planHasContract && customer.planUuid && (
                        <a className="btn btn-sm btn-outline-secondary" href={planContractUrl(companyUuid, customer.planUuid)}
                            target="_blank" rel="noopener noreferrer">
                            <i className="fa-solid fa-file-contract me-2"></i>Ler contrato
                        </a>
                    )}
                </div>

                {total > 0 ? (
                    <>
                        <p className="plan-summary-card__savings mb-1">
                            Você já economizou <strong>{formatBrl(total)}</strong> com o plano
                        </p>
                        <p className="text-muted small mb-0">
                            {month > 0 ? `${formatBrl(month)} só neste mês. ` : ''}
                            {customer.planSavingsUses > 0 ? `Em ${customer.planSavingsUses} ${customer.planSavingsUses === 1 ? 'compra' : 'compras'}` : ''}
                            {since ? `, desde ${since}.` : '.'}
                        </p>
                    </>
                ) : (
                    <p className="text-muted mb-0">Seus descontos do plano aparecem aqui assim que você usar o primeiro benefício.</p>
                )}
            </Card.Body>
        </Card>
    );
};

export default PlanSummaryCard;
